import React, { createContext, useCallback, useState } from "react";

export const BookingAccessControlContext = createContext({
  refreshToken: 0,
  triggerRefresh: () => {},
});

export const BookingAccessControlProvider = ({ children }) => {
  const [refreshToken, setRefreshToken] = useState(0);
  const triggerRefresh = useCallback(
    () => setRefreshToken((v) => v + 1),
    []
  );

  return (
    <BookingAccessControlContext.Provider
      value={{ refreshToken, triggerRefresh }}
    >
      {children}
    </BookingAccessControlContext.Provider>
  );
};
